module.exports = __webpack_public_path__ + "img/Instructor1.c97d60c4.png";